import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "grid-container" }
const _hoisted_2 = { class: "grid-item" }
const _hoisted_3 = { class: "crossword-grid mx-auto" }
const _hoisted_4 = ["id", "onUpdate:modelValue"]
const _hoisted_5 = { class: "clue-number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", null, [
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.crossword.y, (y) => {
              return (_openBlock(), _createElementBlock("tr", { key: y }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.crossword.x, (x) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: x,
                    class: "crossword-grid-cell",
                    style: _normalizeStyle(_ctx.cellStyle)
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      id: _ctx.getCellId(x - 1, y - 1),
                      "onUpdate:modelValue": ($event: any) => ((_ctx.grid[x - 1][y - 1]) = $event),
                      class: _normalizeClass({
                    'black-cell': _ctx.isBlackCell(x - 1, y - 1),
                  }),
                      autocomplete: "off",
                      disabled: "",
                      readonly: ""
                    }, null, 10, _hoisted_4), [
                      [_vModelText, _ctx.grid[x - 1][y - 1]]
                    ]),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.getCellNumber(x - 1, y - 1)), 1)
                  ], 4))
                }), 128))
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}